import i18n from 'modules/core/lib/i18n'

import TrialModal from 'modules/marketplace_modules/components/TrialModal'
import { useUpsellModalContext } from 'modules/upsell/components/UpsellModal/_Context'

type Props = {
  onClose: () => void
}

const ThankYouTrialModal = ({ onClose }: Props) => {
  const { chargebeeModuleId, requestDetail } = useUpsellModalContext()

  if (!chargebeeModuleId) return null

  return (
    <TrialModal
      description={i18n.t('marketplace.modules.trial_upsell.description_thanks')}
      moduleData={{
        chargebeeModuleId: chargebeeModuleId,
        icon: 'fireworks',
      }}
      requestDetail={requestDetail}
      onClose={onClose}
    />
  )
}

export default ThankYouTrialModal
